document.addEventListener('alpine:init', () => {
  Alpine.store('cart_count', {
    count: (window.theme && window.theme.cartItemCount) || 0,
    init() {
      window.addEventListener('shapes:modalcart:afteradditem', (e) => {
        this._setFromFetchedSection(e.detail.response);
      });

      window.addEventListener('shapes:modalcart:cartqtychange', (e) => {
        this._setFromFetchedSection(e.detail.response);
      });
    },
    _setFromFetchedSection(data) {
      const countSectionHTML = data.sections['cart-item-count'];

      this.count = parseInt(
        parseDOMFromString(countSectionHTML).firstElementChild.innerText.trim(),
        10
      );
    },
    countWithText() {
      let string = theme.strings.itemCountOther;

      if (this.count === 1) {
        string = theme.strings.itemCountOne;
      }

// Custom script to update cart count when an item is added
document.addEventListener('ajaxProduct:added', async function() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const countEls = document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble');
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      if (el.classList.contains('hidden')) {
        el.classList.toggle('hidden', cart.item_count === 0);
      }
    });
  } catch (err) {
    console.error('Error updating cart count:', err);
  }
});      return string.replace('{{ count }}', this.count);

// Update cart count when shapes cart item added or section cart count change events fire
window.addEventListener('shapes:cart:item:added', async function(e) {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const countEls = document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble');
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      if (el.classList.contains('hidden')) {
        el.classList.toggle('hidden', cart.item_count === 0);
      }
    });
  } catch (err) {
    console.error('Error updating cart count:', err);
  }
});

window.addEventListener('shopify:section:cart:count:change', async function(e) {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const countEls = document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble');
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      if (el.classList.contains('hidden')) {
        el.classList.toggle('hidden', cart.item_count === 0);
      }
    });
  } catch (err) {
    console.error('Error updating cart count:', err);
  }
});    },
  });
// Update cart count on Add to Cart button clicks
document.body.addEventListener('click', async function(e) {
  if (e.target && e.target.tagName === 'BUTTON' && e.target.textContent.trim().includes('Add to Cart')) {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEls = document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        if (el.classList.contains('hidden')) {
          el.classList.toggle('hidden', cart.item_count === 0);
        }
      });
    } catch (err) {
      console.error('Error updating cart count:', err);
    }
  }
});
});
// Listen for cart:updated event and update cart count
document.addEventListener('cart:updated', async function() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const counts = document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble, [x-text="$store.cart_count.count"]');
    counts.forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });
  } catch (err) {
    console.error('Error updating cart count on cart:updated', err);
  }
});

// Dispatch cart:updated after Add to Cart button click
document.body.addEventListener('click', function(e) {
  if (e.target && e.target.tagName === 'BUTTON' && e.target.textContent.trim().includes('Add to Cart')) {
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

// Update cart count after clicking Add to Cart button with delay
document.body.addEventListener('click', function(e) {
  if (e.target && e.target.tagName === 'BUTTON' && e.target.textContent.trim().toLowerCase().includes('add to cart')) {
    setTimeout(async () => {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        const counts = document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble, [x-text="$store.cart_count.count"]');
        counts.forEach((el) => {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
      } catch (err) {
        console.error('Error updating cart count after delay', err);
      }
    }, 600);
  }
});
});